import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sc-status-progress-item',
    template: '',
    standalone: false
})
export class StatusProgressItemComponent {

  @Input()
  value: any;

  @Input()
  label = '';

  @Input()
  active = false;

  @Output('click')
  itemClick = new EventEmitter<any>();

  get clickable(): boolean {
    return this.itemClick.observers.length > 0;
  }

  emitClick() {
    this.itemClick.emit(this.value);
  }
}
